import { FILTER_OPTIONS, type CreatedByFilter } from '../lib/createdByFilter'

interface CreatedByFilterSelectProps {
  value: CreatedByFilter
  onChange: (value: CreatedByFilter) => void
}

export default function CreatedByFilterSelect({ value, onChange }: CreatedByFilterSelectProps) {
  return (
    <label className="inline-flex items-center gap-2 text-sm text-gray-600">
      Created by
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as CreatedByFilter)}
        className="input w-auto pr-8"
      >
        {FILTER_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  )
}
